export default function headerColor() {
    if(document.querySelector(".main-header")) {
        let header = document.querySelector(".main-header");
        
        if(document.querySelector(".page-wrapper.content-wrapper").classList.contains("header-color")) {
            header.classList.add("change-bg");
        }
    }
}